import React from "react";

import { ConstantInfo } from "../../../core/constantInfo";

const TermsAndConditionsPage: React.FC = () => {
  return (
    <div className="flex flex-col">
      <div className="max-w-screen-2xl w-full place-self-center py-10">
        <section className="mb-12">
          <h1 className="text-3xl font-bold mb-6 text-center">Terms & Conditions</h1>
          <div className="text-lg mb-4 leading-relaxed">
            <p><strong>Effective Date:</strong> 20 Jun 2025</p>
            <p><strong>Website:</strong> https://www.dme-tech.com</p>
            <p><strong>Company:</strong> DME-Tech LLC, 1007 N Orange St, Wilmington, DE 19801, USA</p>
          </div>
        </section>

        <section className="mb-12 bg-content4 bg-opacity-50 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
          <p className="text-lg">
            By accessing or using our services, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use our website or services.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">2. Services Provided</h2>
          <p className="text-lg mb-4">
            DME-Tech LLC provides software tools, calibration files, and support for ECU diagnostics, analysis, and performance tuning.
          </p>
          <p className="text-lg">
            All services are intended exclusively for motorsport, off-road, or research purposes. They must not be used on public roads unless allowed by applicable laws.
          </p>
        </section>

        <section className="mb-12 bg-content4 bg-opacity-50 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">3. No Affiliation</h2>
          <p className="text-lg">
            DME-Tech LLC is not affiliated with BMW AG or any other vehicle manufacturer. All brand names and logos are used solely for identification purposes.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">4. Client Responsibility</h2>
          <p className="text-lg mb-4">
            Clients are solely responsible for the use and installation of any files or software.
          </p>
          <p className="text-lg">
            DME-Tech LLC is not liable for any direct or indirect consequences of using the services, including legal issues, mechanical failures, or compliance violations.
          </p>
        </section>

        <section className="mb-12 bg-content4 bg-opacity-50 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">5. Intellectual Property</h2>
          <p className="text-lg">
            All software, tools, and documentation provided by DME-Tech LLC are protected by copyright and may not be redistributed, resold, or modified without written permission.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">6. Refunds and Revisions</h2>
          <p className="text-lg mb-4">
            Due to the digital nature of our products, all sales are final and non-refundable.
          </p>
          <p className="text-lg mb-4">
            Once a file has been delivered or downloaded, it is considered consumed and cannot be returned.
          </p>
          <p className="text-lg mb-4">
            You acknowledge that digital files and software services cannot be "returned" in the traditional sense, and we cannot verify whether they have been used, copied, or redistributed.
          </p>
          <p className="text-lg mb-4">
            Therefore, we do not offer refunds under any circumstances, unless the delivered file is corrupted, incomplete, or incompatible with the submitted base file. In such cases, we will provide a revision or replacement at no additional cost.
          </p>
          <p className="text-lg mb-4">
            By using our services, you agree to this policy. If you do not accept these conditions, please do not use our website or make any purchases.
          </p>
          <p className="text-lg">
            This policy is aligned with common practices in digital commerce and consistent with U.S. Copyright Law (17 U.S. Code § 103) and consumer protection frameworks regarding non-returnable digital goods.
          </p>
        </section>

        <section className="mb-12 bg-content4 bg-opacity-50 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">7. Legal Use and Compliance</h2>
          <p className="text-lg">
            It is the client's responsibility to comply with local laws and regulations regarding ECU modifications, emissions systems, and road legality. Our solutions are intended for closed-circuit, racing, or experimental use only.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">8. Changes to Terms</h2>
          <p className="text-lg">
            We reserve the right to update these Terms at any time. Continued use of our services implies acceptance of the updated terms.
          </p>
        </section>                
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;